define([], function() {
  'use strict';
  return {
    assets: {
      audio: '/Activity/{activity_id}/audio/{url}',
      image: '/Activity/{activity_id}/image/{url}',
      video: '/Activity/{activity_id}/video/{url}'
    }
  };
});
